<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title font-16 mb-0 text-dark">
      <span>{{ 'lookups.settings' | translate }}</span>
    </p>

    <button (click)="activeModal.dismiss()" aria-label="Close" class="close">
      <span aria-hidden="true" class="font-24 text-muted">
        <i class="mdi mdi-close"></i>
      </span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <div class="mb-4">
              <form #fCreate="ngForm" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                  <div class="col pr-0">
                    <input class="form-control"
                           name="label"
                           ngModel
                           placeholder="{{ 'lookups.action_create_option' | translate }}"
                           required
                           type="text">
                  </div>
                  <div class="col-auto">
                    <button
                        (click)="saveOption(fCreate.form, null)"
                        [createButton]="'lookups.action_create_option' | translate"
                    ></button>
                  </div>
                  <div *ngIf="submitted && fCreate.controls?.label?.errors" class="col-12">
                    <p *ngIf="fCreate.controls?.label?.errors.required" class="text-danger validation-text mb-0">
                      {{ 'angular_validation.field' | translate }}
                      {{ 'angular_validation.required' | translate }}
                    </p>
                  </div>
                </div>
              </form>
            </div>

            <ng-container *ngFor="let option of options; let i = index;">
              <hr class="mt-2 mb-2"/>

              <div class="row align-items-center">
                <div class="col name-col">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="flex-1">
                      <span>{{ option.label }}</span>
                        <div *ngIf="!option.is_active" class="badge badge-danger ml-1 font-12 py-1">
                            <span>{{ 'lookups.is_inactive' | translate }}</span>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-auto pl-0 text-right">
                  <!--<button (click)="moveUp(option)" [disabled]="i === 0" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                  <button (click)="moveDown(option)" [disabled]="i === (options?.length - 1)" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>-->
                  <button
                      (click)="isCollapsed[i] = !isCollapsed[i]"
                      [attr.aria-expanded]="!isCollapsed[i]"
                      [updateButton]="'lookups.action_edit_option' | translate"
                      aria-controls="collapse"
                      type="submit"
                  >
                  </button>
                </div>
              </div>


              <div
                  #collapse="ngbCollapse"
                  [(ngbCollapse)]="!isCollapsed[i]"
              >
                <form #fEdit="ngForm" (keydown.enter)="$event.preventDefault()">
                  <div class="row my-2">
                    <div class="col">
                      <label class="control-label" for="lookups_option_name">
                        <span>{{ 'lookups.label' | translate }}</span>
                      </label>
                      <input [ngModel]="option.label"
                             class="form-control x-1"
                             id="lookups_option_name"
                             name="label"
                             required
                             type="text"/>
                    </div>
                    <div class="col-auto">
                      <div class="form-group">
                        <label class="control-label" for="is_active">
                          <span>{{ 'employees_datetimes_types.is_active' | translate }}</span>
                        </label>
                        <div>
                          <input [ngModel]="option.is_active" data-switch="success" id="{{'is_active-' + option.id}}" name="is_active" type="checkbox">
                          <label for="{{'is_active-' + option.id}}">&nbsp;</label>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="submittedState && fEdit.controls?.label?.errors" class="col-12">
                      <p *ngIf="fEdit.controls?.label?.errors.required" class="text-danger validation-text mb-0">
                        {{ 'angular_validation.field' | translate }}
                        {{ 'angular_validation.required' | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <!--<u (click)="deleteOption(option.id)" class="text-muted mr-2">
                        {{ 'global.action_delete' | translate }}
                      </u>-->
                      <button (click)="saveOption(fEdit.form, option)" class="btn btn-success" submitButton><span>{{ 'global.action_edit' | translate }}</span></button>
                    </div>
                  </div>
                </form>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
